import { forwardRef, type Ref, type SVGProps } from "react";
const IconFactsFeaturesOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <rect width={19} height={2} x={11} y={6} rx={0.97} />
    <rect width={19} height={2} x={11} y={15} rx={0.97} />
    <rect width={19} height={2} x={11} y={24} rx={0.97} />
    <path d="M6.69 5.69 5.4 5.45l-.63-1.23c-.15-.29-.39-.29-.54 0L3.6 5.45l-1.29.24c-.32.06-.41.31-.19.54l.93 1-.19 1.39c0 .33.16.47.45.32l1.19-.6 1.19.6c.29.15.49 0 .45-.32L6 7.24l.93-1c.17-.24.07-.49-.24-.55m0 9-1.29-.24-.63-1.23c-.15-.29-.39-.29-.54 0l-.63 1.23-1.29.24c-.32.06-.41.31-.19.54l.93 1-.19 1.38c0 .33.16.47.45.32l1.19-.6 1.19.6c.29.15.49 0 .45-.32L6 16.24l.93-1c.17-.24.07-.49-.24-.55m0 9-1.29-.24-.63-1.23c-.15-.29-.39-.29-.54 0l-.63 1.23-1.29.24c-.32.06-.41.31-.19.54l.93 1-.19 1.38c0 .33.16.47.45.32l1.19-.6 1.19.6c.29.15.49 0 .45-.32L6 25.24l.93-1c.17-.24.07-.49-.24-.55" />
  </svg>
);
const ForwardRef = forwardRef(IconFactsFeaturesOutlineSVG);
ForwardRef.displayName = "IconFactsFeaturesOutline";
export { ForwardRef as IconFactsFeaturesOutline };
